/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_VENDOR,
  LOAD_VENDOR_SUCCESS,
  LOAD_VENDOR_ERROR,
  CREATE_VENDOR,
  CREATE_VENDOR_SUCCESS,
  CREATE_VENDOR_ERROR,
  UPDATE_VENDOR,
  UPDATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_ERROR,
  DELETE_VENDOR,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_ERROR,
  LOAD_VENDOR_RECORDS_META_DATA,
  LOAD_VENDOR_RECORDS_META_DATA_SUCCESS,
  LOAD_VENDOR_RECORDS_META_DATA_ERROR,
  LOAD_VENDOR_COLLECT,
  LOAD_VENDOR_COLLECT_SUCCESS,
  LOAD_VENDOR_COLLECT_ERROR,
  LOAD_VENDOR_PAY,
  LOAD_VENDOR_PAY_SUCCESS,
  LOAD_VENDOR_PAY_ERROR,
  LOAD_VENDOR_TRANSACTION,
  LOAD_VENDOR_TRANSACTION_SUCCESS,
  LOAD_VENDOR_TRANSACTION_ERROR,
  LOAD_VENDOR_CATEGORY,
  LOAD_VENDOR_CATEGORY_SUCCESS,
  LOAD_VENDOR_CATEGORY_ERROR,
  CREATE_VENDOR_CATEGORY,
  CREATE_VENDOR_CATEGORY_SUCCESS,
  CREATE_VENDOR_CATEGORY_ERROR,
} from "./constants";

// load Vendor
export function loadVendor(vendorList) {
  return {
    type: LOAD_VENDOR,
    vendorList,
  };
}

export function loadVendorSuccess(vendor_list, success) {
  return {
    type: LOAD_VENDOR_SUCCESS,
    vendor_list,
    success,
  };
}

export function loadVendorError(error) {
  return {
    type: LOAD_VENDOR_ERROR,
    error,
  };
}

// load Vendor
export function loadVendorCollect(vendorList) {
  return {
    type: LOAD_VENDOR_COLLECT,
    vendorList,
  };
}

export function loadVendorCollectSuccess(vendor_collect_list, success) {
  return {
    type: LOAD_VENDOR_COLLECT_SUCCESS,
    vendor_collect_list,
    success,
  };
}

export function loadVendorCollectError(error) {
  return {
    type: LOAD_VENDOR_COLLECT_ERROR,
    error,
  };
}

// load Vendor
export function loadVendorPay(vendorList) {
  return {
    type: LOAD_VENDOR_PAY,
    vendorList,
  };
}

export function loadVendorPaySuccess(vendor_pay_list, success) {
  return {
    type: LOAD_VENDOR_PAY_SUCCESS,
    vendor_pay_list,
    success,
  };
}

export function loadVendorPayError(error) {
  return {
    type: LOAD_VENDOR_PAY_ERROR,
    error,
  };
}

// load Vendor
export function loadVendorTransaction(vendorList) {
  return {
    type: LOAD_VENDOR_TRANSACTION,
    vendorList,
  };
}

export function loadVendorTransactionSuccess(vendor_transaction_list, success) {
  return {
    type: LOAD_VENDOR_TRANSACTION_SUCCESS,
    vendor_transaction_list,
    success,
  };
}

export function loadVendorTransactionError(error) {
  return {
    type: LOAD_VENDOR_TRANSACTION_ERROR,
    error,
  };
}

export function loadVendorCategory(categoryList) {
  return {
    type: LOAD_VENDOR_CATEGORY,
    categoryList,
  };
}

export function loadVendorCategorySuccess(category_list, success) {
  return {
    type: LOAD_VENDOR_CATEGORY_SUCCESS,
    category_list,
    success,
  };
}

export function loadVendorCategoryError(error) {
  return {
    type: LOAD_VENDOR_CATEGORY_ERROR,
    error,
  };
}

//category list
export function createVendorCategoryList(categoryList) {
  return {
    type: CREATE_VENDOR_CATEGORY,
    categoryList,
  };
}

export function createVendorCategoryListSuccess(categoryList, success) {
  return {
    type: CREATE_VENDOR_CATEGORY_SUCCESS,
    categoryList,
    success,
  };
}

export function createVendorCategoryListError(error) {
  return {
    type: CREATE_VENDOR_CATEGORY_ERROR,
    error,
  };
}

// load Vendor
export function createVendorList(vendorList) {
  return {
    type: CREATE_VENDOR,
    vendorList,
  };
}

export function createVendorListSuccess(vendorList, success) {
  return {
    type: CREATE_VENDOR_SUCCESS,
    vendorList,
    success,
  };
}

export function createVendorListError(error) {
  return {
    type: CREATE_VENDOR_ERROR,
    error,
  };
}
// load Vendor
export function updateVendorList(vendorList) {
  return {
    type: UPDATE_VENDOR,
    vendorList,
  };
}

export function updateVendorListSuccess(vendorList, success) {
  return {
    type: UPDATE_VENDOR_SUCCESS,
    vendorList,
    success,
  };
}

export function updateVendorListError(error) {
  return {
    type: UPDATE_VENDOR_ERROR,
    error,
  };
}
// load Vendor
export function deleteVendorList(vendorList) {
  return {
    type: DELETE_VENDOR,
    vendorList,
  };
}

export function deleteVendorListSuccess(vendorList, success) {
  return {
    type: DELETE_VENDOR_SUCCESS,
    vendorList,
    success,
  };
}

export function deleteVendorListError(error) {
  return {
    type: DELETE_VENDOR_ERROR,
    error,
  };
}

export function loadVendorRecordsMetaData() {
  return {
    type: LOAD_VENDOR_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadVendorRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_VENDOR_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadVendorRecordsMetaDataError(error) {
  return {
    type: LOAD_VENDOR_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadVendor,
  loadVendorSuccess,
  loadVendorError,

  loadVendorCollect,
  loadVendorCollectSuccess,
  loadVendorCollectError,

  loadVendorPay,
  loadVendorPaySuccess,
  loadVendorPayError,

  loadVendorCategory,
  loadVendorCategorySuccess,
  loadVendorCategoryError,

  createVendorCategoryList,
  createVendorCategoryListSuccess,
  createVendorCategoryListError,

  loadVendorTransaction,
  loadVendorTransactionSuccess,
  loadVendorTransactionError,

  createVendorList,
  createVendorListSuccess,
  createVendorListError,

  updateVendorList,
  updateVendorListSuccess,
  updateVendorListError,

  deleteVendorList,
  deleteVendorListSuccess,
  deleteVendorListError,

  loadVendorRecordsMetaData,
  loadVendorRecordsMetaDataSuccess,
  loadVendorRecordsMetaDataError,
};

export default actions;
